// Auto-advance carousels on mobile
(function () {
  function initCarousel(carousel, itemSelector) {
    var cards = carousel.querySelectorAll(itemSelector);
    if (cards.length < 2) return;
    var current = 0;
    setInterval(function () {
      current = (current + 1) % cards.length;
      carousel.scrollTo({ left: cards[current].offsetLeft, behavior: 'smooth' });
    }, 3000);
  }

  function initAllCarousels() {
    if (window.innerWidth > 767) return;
    document.querySelectorAll('.price-card').forEach(function (el) {
      initCarousel(el, '.single-card');
    });
    var investItem = document.querySelector('#invest .item');
    if (investItem) initCarousel(investItem, '.card');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }
})();

fetch("https://goldapi.deuslab.com/?function=grain_value&key=pepe", { method: "GET" })
  .then(res => res.json())
  .then(res => {
    const set = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
    set("chartDate",    res.data.au.date);
    set("chartSymbol",  res.data.au.currency_symbol);
    set("chartValue",   ` ${res.data.au.value}/gr`);
    set("chartDate2",   res.data.ag.date);
    set("chartSymbol2", res.data.ag.currency_symbol);
    set("chartValue2",  ` ${res.data.ag.value}/gr`);
    set("chartDate3",   res.data.pd.date);
    set("chartSymbol3", res.data.pd.currency_symbol);
    set("chartValue3",  ` ${res.data.pd.value}/gr`);
  })
  .catch(() => {});